export const PC_SCROLL_PADDING = 32;
export const PC_CAROUSEL_BUTTON_WIDTH = 64;
export const PC_CAROUSEL_MARGIN = 32;
export const PC_ITEM_LEFT_MARGIN = 16;
export const PC_RANKING_ITEM_LEFT_MARGIN = 19;

export const SP_SCROLL_PADDING = 16;
export const SP_CAROUSEL_BUTTON_WIDTH = 32;
export const SP_CAROUSEL_MARGIN = 16;
export const SP_ITEM_LEFT_MARGIN = 8;
export const SP_RANKING_ITEM_LEFT_MARGIN = 11;
